import React, { Component } from 'react';
import logo from './logo.svg';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { CustomNav } from '../Components/CustomNav';
import { PlayerCard } from '../Components/PlayerCard';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import ListSubheader from '@material-ui/core/ListSubheader';
import { Calendar, TileContent } from 'react-calendar/dist/entry.nostyle';
import './Dashboard.css';
import axios from 'axios';
import moment from 'moment';
import NewCalendar from 'rc-calendar';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { FadeLoader } from 'react-spinners';
import Tooltip from 'rc-tooltip';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { getHenriStyle, getCapColour } from '../Utility/utility.js';

let recentGames = require('../Mock/dashboard-recent-games.json');
let teamStats = require('../Mock/dashboard-team-stats.json');
let easternConferenceStandings = require('../Mock/dashboard-eastern-conference-standings.json');
let westernConferenceStandings = require('../Mock/dashboard-western-conference-standings.json');
let recentNews = require('../Mock/dashboard-recent-news.json');
let sampleDates = [
  new Date(2018, 7, 7),
  new Date(2018, 7, 8),
  new Date(2018, 7, 10),
  new Date(2018, 10, 9)
];

export const navigatePage = () => dispatch => {
  /* do something before redirection */
  console.log('navigating');
  dispatch(push('/'));
};

//import Calendar from 'react-calendar/dist/entry.nostyle';
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      standings: easternConferenceStandings,
      curStandings: 'conf',
      pageSize: 20,
      scheduleStart: 6,
      scheduleEnd: 12
    };
  }

  playerStatsColumns = [
    {
      Header: 'Player',
      id: 'player',
      accessor: d => d.player_name,
      style: { textAlign: 'left' },
      minWidth: 150
    },
    {
      Header: 'GP',
      id: 'gp',
      accessor: d => d.games_played,
      minWidth: 40
    },
    {
      Header: 'G',
      id: 'g',
      accessor: d => d.goals,
      minWidth: 40
    },
    {
      Header: 'A',
      id: 'assists',
      accessor: d => d.assists,
      minWidth: 40
    },
    {
      Header: 'P',
      id: 'points',
      accessor: d => d.points,
      minWidth: 40
    },
    {
      Header: '+/-',
      id: 'plus_minus',
      accessor: d => d.plus_minus,
      minWidth: 40
    },
    {
      Header: 'CF%',
      id: 'cf_pct',
      accessor: d => (d.corsi_pct ? (d.corsi_pct * 100).toFixed(2) : null),
      minWidth: 60
    }
  ];
  standingsColumns = [
    {
      Header: 'Team',
      id: 'team',
      accessor: d => d.team,
      Cell: row => (
        <div>
          <img
            src={
              this.state.curStandings === 'wc'
                ? this.state.standings
                    .find(x => x.standings.find(y => y.team === row.value))
                    .standings.find(z => z.team === row.value).logo_link
                : this.state.standings.find(x => x.team === row.value).logo_link
            }
            width="20"
            height="20"
          />{' '}
          {row.value}
        </div>
      ),
      minWidth: 80
    },
    {
      Header: 'GP',
      id: 'gp',
      accessor: d => d.gp,
      minWidth: 50
    },
    {
      Header: 'W',
      id: 'wins',
      accessor: d => d.ovrl_w,
      minWidth: 50
    },
    {
      Header: 'L',
      id: 'losses',
      accessor: d => d.ovrl_l,
      minWidth: 50
    },
    {
      Header: 'OTL',
      id: 'otl',
      accessor: d => d.ovrl_otl,
      minWidth: 50
    },
    {
      Header: 'P',
      id: 'points',
      accessor: d => d.points,
      minWidth: 50
    },
    {
      Header: 'ROW',
      id: 'row',
      accessor: d => d.row,
      minWidth: 50
    },
    {
      Header: 'GF',
      id: 'gf',
      accessor: d => d.gf,
      minWidth: 50
    },
    {
      Header: 'GA',
      id: 'ga',
      accessor: d => d.ga,
      minWidth: 50
    },
    {
      Header: 'DIFF',
      id: 'diff',
      accessor: d => (d.g_diff > 0 ? '+' + d.g_diff : d.g_diff),
      minWidth: 50
    },
    {
      Header: 'STRK',
      id: 'streak',
      accessor: d => d.streak,
      minWidth: 50
    }
  ];
  componentWillMount() {
    let currentComponent = this;
    axios
      .all([
        axios.get(apiServerUrl + '/transactions', requestOptions()),
        axios.get(apiServerUrl + '/team_stats?team=PIT', requestOptions()),
        axios.get(apiServerUrl + '/calendar', requestOptions()),
        axios.get(
          apiServerUrl + '/standings?view=' + this.state.curStandings,
          requestOptions()
        ),
        axios.get(apiServerUrl + '/schedule', requestOptions())
      ])
      .then(
        axios.spread(
          (transactions, players, calendarData, standings, schedule) => {
            //console.log(homeRes.data);
            //console.log(awayRes.data);

            currentComponent.setState({
              players: players.data ? players.data : [],
              transactions: transactions.data ? transactions.data : [],
              calendarData: calendarData.data ? calendarData.data : [],
              pageSize: players.data.length > 0 ? players.data.length : 0,
              schedule: schedule.data ? schedule.data : [],
              standings:
                standings.data.length > 0 ? standings.data[0].standings : [],
              calendarGameDates: calendarData.data
                ? calendarData.data.map(d => {
                    var f = new Date(d.game_start);
                    f.setHours(0, 0, 0, 0);
                    return f.getTime();
                  })
                : []
            });
          }
        )
      );
    // separating team_summary because it frequently 500's
    axios
      .get(apiServerUrl + '/team_summary', requestOptions())
      .then(function(response) {
        currentComponent.setState({
          teamSummary: response.data ? response.data : []
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  openBigCalendar() {
    this.props.dispatch(push('/calendar'));
  }

  changeStandings(e) {
    console.log(e);
    let currentComponent = this;
    if (e === 'league') {
      axios
        .get(apiServerUrl + '/standings?view=league', requestOptions())
        .then(function(response) {
          console.log(response.data);
          currentComponent.setState({
            standings: response.data.find(x => (x.header = e)).standings,
            curStandings: 'league'
          });
        });
      document.getElementById('league').classList.add('active');
      document.getElementById('east').classList.remove('active');
      document.getElementById('west').classList.remove('active');
      document.getElementById('div').classList.remove('active');
      document.getElementById('wc').classList.remove('active');
    } else if (e === 'east' || e === 'west') {
      axios
        .get(apiServerUrl + '/standings?view=conf', requestOptions())
        .then(function(response) {
          console.log(response.data);
          currentComponent.setState({
            standings:
              e === 'east'
                ? response.data[0].standings
                : response.data[1].standings,
            curStandings: 'conf'
          });
        });
      document.getElementById('league').classList.remove('active');
      if (e === 'east') {
        document.getElementById('east').classList.add('active');
        document.getElementById('west').classList.remove('active');
      } else {
        document.getElementById('west').classList.add('active');
        document.getElementById('east').classList.remove('active');
      }
      document.getElementById('div').classList.remove('active');
      document.getElementById('wc').classList.remove('active');
    } else if (e === 'div') {
      document.getElementById('league').classList.remove('active');
      document.getElementById('east').classList.remove('active');
      document.getElementById('west').classList.remove('active');
      document.getElementById('wc').classList.remove('active');
      axios
        .get(apiServerUrl + '/standings?view=div', requestOptions())
        .then(function(response) {
          console.log(response.data, currentComponent.state.curStandings);
          if (
            currentComponent.state.curStandings === 'Atlantic' ||
            currentComponent.state.curStandings === 'Pacific' ||
            currentComponent.state.curStandings === 'Metropolitan' ||
            currentComponent.state.curStandings === 'Central'
          ) {
            currentComponent.setState({
              standings: response.data.find(
                x => x.header === currentComponent.state.curStandings
              ).standings,
              curStandings: 'div'
            });
          }
        });
    }
    if (e === 'wc') {
      axios
        .get(apiServerUrl + '/standings?view=wc', requestOptions())
        .then(function(response) {
          console.log(response.data);
          currentComponent.setState({
            standings: response.data,
            curStandings: 'wc'
          });
        });
      document.getElementById('league').classList.remove('active');
      document.getElementById('east').classList.remove('active');
      document.getElementById('west').classList.remove('active');
      document.getElementById('div').classList.remove('active');
      document.getElementById('wc').classList.add('active');
    }
  }

  changeSchedule(e, prevOrNext) {
    if (prevOrNext === 'prev' && this.state.scheduleStart - 6 >= 0) {
      this.setState((prev, e) => ({
        scheduleStart: prev.scheduleStart - 6,
        scheduleEnd: prev.scheduleEnd - 6
      }));
    } else if (prevOrNext === 'next' && this.state.scheduleEnd + 6 <= 24) {
      this.setState((prev, e) => ({
        scheduleStart: prev.scheduleStart + 6,
        scheduleEnd: prev.scheduleEnd + 6
      }));
    }
  }

  render() {
    return (
      <div>
        <header className="nav">
          <CustomNav />
        </header>
        <div className="flex-grid" style={{ color: '#59758a' }}>
          {/*  Recent Games */}
          <div
            className="flex-container gutter-right"
            style={{
              flex: 6,
              textAlign: 'center',
              display: 'flex',
              flexWrap: 'wrap'
            }}
          >
            {this.state.schedule &&
              this.state.schedule
                .slice(this.state.scheduleStart, this.state.scheduleEnd)
                .map(tile => (
                  <div
                    className="flex-card"
                    style={{ flex: '1 0 33%', margin: '0px' }}
                  >
                    {/*split into top panel and bottom*/}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                          padding: '0 1em 0 0'
                        }}
                      >
                        <span
                          style={{
                            color: 'rgb(228, 0, 0)',
                            fontWeight: '800',
                            fontSize: '12px'
                          }}
                        >
                          {moment(tile.game_start).format('llll')}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          marginBottom: '7px',
                          padding: '1em 1em 0 1em',
                          justifyContent: 'space-evenly'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flex: '1',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly'
                          }}
                        >
                          <div>
                            <img src={tile.away_logo} width="70" height="70" />
                            <div>{tile.away}</div>
                            <div>{tile.away_record}</div>
                          </div>
                          <div
                            style={{ fontSize: '30px', fontWeight: 'light' }}
                          >
                            {tile.away_score}
                          </div>
                        </div>

                        <div
                          style={{
                            borderLeft: '2px solid #8198a5',
                            display: 'flex',
                            flex: '1',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly'
                          }}
                        >
                          <div
                            style={{ fontSize: '30px', fontWeight: 'light' }}
                          >
                            {tile.home_score}
                          </div>
                          <div>
                            <img src={tile.home_logo} width="70" height="70" />
                            <div>{tile.home}</div>
                            <div>{tile.home_record}</div>
                          </div>
                        </div>

                        {/*<div style={{ borderLeft: '2px solid #8198a5', display: 'flex', flexDirection: 'column', flexGrow: '6', fontSize: '16px' }}>
                      <div>2<img src={"https://tsnimages.tsn.ca/ImageProvider/TeamLogo?seoId=" + tile.team2.replace(" ", "-").replace(" ", "-").toLowerCase() + "&width=%s&height=%s"} alt="Smiley face" width="50" height="50"></img></div>

                    </div>*/}
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          borderTop: '1px solid #d7e2f7',
                          justifyContent: 'space-evenly',
                          padding: '0.5em 1em 0 1em',
                          fontSize: '12px'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flex: 1
                          }}
                        >
                          <div style={{ paddingRight: '0.5em' }}>
                            <strong>{tile.away}</strong>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              textAlign: 'left'
                            }}
                          >
                            {tile.away_leaders.p1_name && (
                              <div>
                                <div>
                                  {tile.away_leaders.p1_name}:{' '}
                                  {tile.away_leaders.p1_summary}
                                </div>
                                <div>
                                  {tile.away_leaders.p2_name}:{' '}
                                  {tile.away_leaders.p2_summary}
                                </div>
                                <div>
                                  {tile.away_leaders.p3_name}:{' '}
                                  {tile.away_leaders.p3_summary}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flex: 1
                          }}
                        >
                          <div style={{ paddingRight: '0.5em' }}>
                            <strong>{tile.home}</strong>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              textAlign: 'left'
                            }}
                          >
                            {tile.home_leaders.p1_name && (
                              <div>
                                <div>
                                  {tile.home_leaders.p1_name}:{' '}
                                  {tile.home_leaders.p1_summary}
                                </div>
                                <div>
                                  {tile.home_leaders.p2_name}:{' '}
                                  {tile.home_leaders.p2_summary}
                                </div>
                                <div>
                                  {tile.home_leaders.p3_name}:{' '}
                                  {tile.home_leaders.p3_summary}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            {this.state.schedule && (
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between',
                  background: 'none'
                }}
              >
                <Button
                  onClick={e => {
                    this.changeSchedule(e, 'prev');
                  }}
                >
                  PREVIOUS 6 GAMES
                </Button>
                <Button
                  onClick={e => {
                    this.changeSchedule(e, 'next');
                  }}
                  style={{ float: 'right' }}
                >
                  NEXT 6 GAMES
                </Button>
              </div>
            )}
          </div>

          {/* Calendar */}
          <div
            className="col"
            style={{
              flex: 3,
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#082539'
            }}
          >
            <div style={{ alignItems: 'stretch', width: '100%' }}>
              <Calendar
                className="calendar"
                style={{ background: '#1f3d50', width: '100%' }}
                tileClassName={({ date, view }) => {
                  // console.log("---------------------------this.state.calendarData---------------------------");
                  // console.log(this.state.calendarData);
                  // console.log(this.state.calendarGameDates);
                  // console.log("-----------------------------------------------------------------------------");

                  return view === 'month' &&
                    this.state.calendarGameDates &&
                    this.state.calendarGameDates.includes(date.getTime())
                    ? 'dashboard-calendar-event'
                    : '';
                  // This line below is for comparing to static test data in sampleDates variable
                  // return (view === 'month' && (sampleDates.map((d) => { return d.getTime() }).includes((date).getTime()))) ? 'dashboard-calendar-event' : "";
                }}
                onClickDay={(date, value) => console.log('Clicked day ' + date)}
              />
              <Button
                style={{ width: '100%' }}
                onClick={e => this.openBigCalendar()}
              >
                Expand Calendar
              </Button>
              {/* <Calendar className="calendar" style={{ background: '#1f3d50', width: '100%' }} value={[new Date(2017, 0, 1), new Date(2017, 7, 1)]}>
                <TileContent tileContent={({ date, view }) => view === 'month' && date.getDate() === 18 && date.getMonth() === 8 ? <p style={{color: 'green'}}>•</p> : null} />
                </Calendar> */}
            </div>
            <div
              style={{
                height: '1.9em',
                width: '100%',
                backgroundColor: '#082539',
                marginTop: '0.2em'
              }}
            />
            <div
              style={{
                outline: '0.2em solid #61696e',
                backgroundColor: 'white',
                paddingBottom: '1em'
              }}
            >
              <div style={{ display: 'flex' }}>
                <div
                  style={{
                    flex: 1,
                    justifyContent: 'center',
                    textAlign: 'center',
                    verticalAlign: 'top'
                  }}
                >
                  <h5>
                    <strong>UPCOMING OPPONENT: </strong>
                  </h5>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1 }}>
                      {/*<strong style={{fontSize: '20px'}}>@</strong>*/}
                      {this.state.teamSummary && (
                        <img
                          src={this.state.teamSummary.next_game.opponent_logo}
                          width="84"
                          height="84"
                        />
                      )}
                    </div>
                    <div style={{ flex: 1, fontSize: '20px' }}>
                      <div>
                        <strong>
                          {this.state.teamSummary &&
                            this.state.teamSummary.next_game.date}{' '}
                          {this.state.teamSummary &&
                            this.state.teamSummary.next_game.time}
                        </strong>
                      </div>
                      <div>
                        {this.state.teamSummary &&
                          this.state.teamSummary.next_game.opponent_record}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{ flex: 1, textAlign: 'center', verticalAlign: 'top' }}
                >
                  <h5>
                    <strong>RECENT RESULTS:</strong>
                  </h5>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      borderLeftStyle: 'solid',
                      fontSize: '13px'
                    }}
                  >
                    {this.state.teamSummary &&
                      this.state.teamSummary.last_games.map(key => (
                        <div
                          style={{
                            flex: 1,
                            paddingBottom: '1em',
                            alignItems: 'stretch'
                          }}
                        >
                          <strong>{key.date}</strong>
                          <br />
                          <img src={key.opponent_logo} width="25" height="25" />
                          <br />
                          {key.opponent}
                          <br />
                          {key.result} {key.score}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                outline: '0.2em solid #61696e',
                backgroundColor: 'white'
              }}
            >
              <div style={{ display: 'flex' }}>
                <div
                  style={{
                    flex: 1,
                    width: '50%',
                    justifyContent: 'center',
                    textAlign: 'center',
                    verticalAlign: 'top'
                  }}
                >
                  <h4>Current Cap Space</h4>
                  <div
                    style={{
                      display: 'flex',
                      textAlign: 'center',
                      justifyContent: 'center',
                      alignSelf: 'top',
                      alignItems: 'flex-start'
                    }}
                  >
                    <h3 style={{ marginTop: '-0.1em' }}>
                      {this.state.teamSummary && (
                        <strong
                          style={{
                            color: getHenriStyle(
                              getCapColour(
                                this.state.teamSummary.cap_space.toLocaleString()
                              )
                            )
                          }}
                        >
                          {'$' +
                            this.state.teamSummary.cap_space.toLocaleString()}
                        </strong>
                      )}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="flex-grid"
          style={{ alignItems: 'baseline', justifyContent: 'space-between' }}
        >
          <div style={{ flex: 2 }}>
            <table className="table-headers" style={{ width: '100%' }}>
              <tr>
                <th id="league" onClick={e => this.changeStandings('league')}>
                  LEAGUE
                </th>
                <th id="east" onClick={e => this.changeStandings('east')}>
                  EAST
                </th>
                <th id="west" onClick={e => this.changeStandings('west')}>
                  WEST
                </th>
                <th id="wc" onClick={e => this.changeStandings('wc')}>
                  WILD CARD
                </th>
                <th id="div" onClick={e => this.changeStandings('div')}>
                  <select
                    style={{ color: 'white', background: '#61696E' }}
                    onChange={e =>
                      this.setState({ curStandings: e.target.value })
                    }
                  >
                    <option value="">DIVISION</option>
                    <option value="Atlantic">Atlantic</option>
                    <option value="Metropolitan">Metropolitan</option>
                    <option value="Central">Central</option>
                    <option value="Pacific">Pacific</option>
                  </select>
                </th>
              </tr>
            </table>
            {this.state.curStandings === 'wc' &&
              this.state.standings.map(division => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{
                      width: '100%',
                      background: '#61696E',
                      color: 'white',
                      paddingLeft: '1em'
                    }}
                  >
                    {division.header.toUpperCase()}
                  </div>
                  <ReactTable
                    data={division.standings}
                    columns={this.standingsColumns}
                    filterable={false}
                    showPagination={false}
                    defaultSorted={[{ id: 'points', desc: true }]}
                    ref="wildCardTable"
                    resizable={false}
                    pageSize={division.standings.length}
                  />
                </div>
              ))}
            {this.state.curStandings !== 'wc' && (
              <ReactTable
                data={this.state.standings}
                columns={this.standingsColumns}
                filterable={false}
                showPagination={false}
                defaultSorted={[{ id: 'points', desc: true }]}
                ref="standingsTable"
                resizable={false}
                pageSize={this.state.standings.length}
              />
            )}
          </div>

          {/* Transactions & Signings */}
          <div
            className="col"
            style={{
              flex: 1,
              outline: '0.2em solid #61696e',
              backgroundColor: '#1f3d50',
              color: 'white',
              overflow: 'auto',
              paddingTop: '0.5em',
              margin: '0 1em'
            }}
          >
            <strong style={{ padding: '0.5em', textAlign: 'center' }}>
              Transactions/Signings
            </strong>
            <ul style={{ padding: '0' }}>
              {this.state.transactions &&
                this.state.transactions.map(news => (
                  <li className="newsli">{news}</li>
                ))}
            </ul>
          </div>

          {/* Player Listing */}
          <div className="col" style={{ flex: 2, color: '#072338' }}>
            <ReactTable
              data={this.state.players}
              filterable={false}
              showPagination={false}
              defaultSortDesc={true}
              defaultSorted={[{ id: 'points', desc: true }]}
              ref="playerCardTable"
              columns={this.playerStatsColumns}
              resizable={false}
              noDataText={
                <FadeLoader color={'#123abc'} loading={this.state.loading} />
              }
              pageSize={this.state.pageSize}
              className="-striped -highlight"
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    state
  };
}

const connectedDashboard = connect(mapStateToProps)(Dashboard);
export { connectedDashboard as Dashboard };



// WEBPACK FOOTER //
// ./src/Pages/Dashboard.js